export const isTouchingEvent = () => window.IS_TOUCHED;
